export const INDEX_PATH = '/';
export const HOME_PATH = '/home';
export const ABOUT_PATH = '/about';
export const SERVICES_PATH = '/services';
export const STAFF_PATH = '/staff';
export const LOGIN_PATH = '/login';
export const REGISTER_PATH = '/register';
export const CHECK_EMAIL_PATH = '/check-email';
export const SET_NEW_PASSWORD_PATH = '/set-new-password';
export const COUNTERS_PATH = '/counters';
export const USERS_PATH = '/users';
export const PROFILE_PATH = '/profile';
export const ACCESS_IS_DENIED_PATH = '/access-is-denied';
export const NEWS_PATH = '/news';
export const STYLE_MODULE_PATH = '/style-module';
